import React, { useEffect } from 'react';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
import * as d3 from "d3";
import './GraphUI.css'
var isMounted = false;
const GraphUI = (props: UIProperties<GraphUIConfig>) => {
	useEffect(() => {
		if(isMounted) {
			isMounted = false;
			
			const data: any[] = [];

			if(props.parameters.maxData.length !== props.parameters.minData.length) {
				throw Error("Max and min data must have same length");
			}
			const percentage = props.parameters.interpolationPercentage;

			for(var i = 0; i < props.parameters.maxData.length; i++) {
				var max = props.parameters.maxData[i];
				var min = props.parameters.minData[i];
				var interpolatedVal = (percentage * (max - min) / 100) + min;
				data.push(interpolatedVal);
			}

			// include an svg element in the .viz container
			const margin = {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0,
			};
			
			const width = props.parameters.width - (margin.left + margin.right);
			const height = props.parameters.height - (margin.top + margin.bottom);
			// const width = 1200 - (margin.left + margin.right);
			// const height = 600 - (margin.top + margin.bottom);
			
			const svg = d3
				.select('.viz')
				.append('svg')
				.attr(
					'viewBox',
					`0 0 ${width + (margin.left + margin.right)} ${height +
					(margin.top + margin.bottom)}`
				);
			
			const group = svg
				.append('g')
				.attr('transform', `translate(${margin.left} ${margin.top})`);
			
			// horizontally place the data points according to their index
			const xScale = d3
				.scaleLinear()
				.domain([0, data.length])
				.range([0, width]);
			
			// vertically consider the actual data points, starting at 0
			const yScale = d3
				.scaleLinear()
				.domain([0, (d3 as any).max(data)])
				// map smaller values to higher y coordinates (farther from the top)
				.range([height, 0]);
			
			// line function considering the index and value of the data points
			const line = d3
				.line()
				.x((d: any, i: any) => xScale(i))
				.y((d: any) => yScale(d))
				.curve(d3.curveCatmullRom);
			
			// grid lines included behind the line itself
			// group
			// 	.selectAll('path.grid-line')
			// 	.data(data)
			// 	.enter()
			// 	.append('path')
			// 	.attr('class', 'grid-line')
			// 	.attr('d', (d: any, i: any) => {
			// 		const x = xScale(i);
			// 		const y = yScale(d);
			// 		return `M ${x} ${y} v ${height - y}`;
			// 	})
			// 	.attr('fill', 'none')
			// 	.attr('stroke', 'hsl(140, 90%, 95%)')
			// 	.attr('stroke-width', 3)
			// 	.attr('stroke-dasharray', 8)
			// 	.attr('opacity', (d: any, i: any) => (i % 3 === 0 ? 0.2 : 0));
			
			// line describing the data
			group
				.append('path')
				.attr('d', line(data))
				.attr('fill', 'none')
				.attr('stroke', props.parameters.color)
				.attr('stroke-width', props.parameters.strokeWidth)
				.attr('stroke-linecap', 'round');
			
			// // instead of the default axis, fabricate two lines spanning the visualization's height and width
			// const axes = group
			// 	.append('g')
			// 	.attr('fill', 'none')
			// 	.attr('stroke', 'hsl(140, 90%, 40%)')
			// 	.attr('stroke-width', 8)
			// 	.attr('stroke-linejoin', 'round')
			// 	.attr('stroke-linecap', 'round');
			
			// axes
			// 	.append('path')
			// 	.attr('d', `M 0 ${height} v -${height} l 10 16 h -20 l 10 -16`);
			
			// axes
			// 	.append('path')
			// 	.attr('d', `M 0 ${height} h ${width - 50} l -16 10 v -20 l 16 10`);
			
			// const labels = group
			// 	.append('g')
			// 	.style('font-weight', 900)
			// 	.style('font-size', '2rem')
			// 	.style('text-transform', 'uppercase')
			// 	.style('letter-spacing', '0.05rem')
			// 	.attr('fill', 'currentColor')
			// 	.attr('text-anchor', 'middle');
			
			// labels
			// 	.append('text')
			// 	.attr('transform', `translate(-20 ${height / 2}) rotate(-90)`)
			// 	.text('Energy');
			
			// labels
			// 	.append('text')
			// 	.attr('transform', `translate(${height} ${width / 2})`)
			// 	.text('Time');
			
			// for a proof of concept, include a circle for a data point at random
			// const randomIndex = (arr: any) => Math.floor(Math.random() * arr.length);
			// const index = randomIndex(data);
			
			// ultimately the idea is to position the circle on a specific set of coordinates and allow to reposition the group on click
			// const dataPoint = group
			// 	.append('g')
			// 	.attr('transform', () => {
			// 		const x = xScale(index);
			// 		const y = yScale(data[index]);
			// 		return `translate(${x} ${y})`;
			// 	});
			
			// // for the data point add a circle and a text describing its value
			// dataPoint
			// 	.append('circle')
			// 	.attr('cx', 0)
			// 	.attr('cy', 0)
			// 	.attr('r', 22)
			// 	.attr('fill', 'hsl(140, 80%, 100%)')
			// 	.attr('stroke', 'hsl(140, 90%, 40%)')
			// 	.attr('stroke-width', 6)
			// 	.attr('stroke-linecap', 'round');
			
			
			// const format = d3.format('.2');
			// dataPoint
			// 	.append('text')
			// 	.style('font-weight', 700)
			// 	.style('font-size', '5rem')
			// 	.attr('fill', 'hsl(60, 90%, 40%)')
			// 	.attr('text-anchor', 'middle')
			// 	.attr('transform', `translate(0 -50)`)
			// 	.text(`${format(data[index])}%`);
		}

		return () => {
			isMounted = true;
		}
	}, [])
	return (
		<div id="vidId" className='viz modal-disable-select' 
		style={props.parameters.isDebug ? {} : {
			overflow: 'none'
		}}></div>
	);
};

export interface GraphUIConfig extends BaseConfig{
	width: number;
	height: number;
	color: string;
	maxData: number[];
	minData: number[];
	interpolationPercentage: number; 
	isDebug?: boolean;
	strokeWidth: number;
}

export default GraphUI;